__turbopack_context__.v({
  "contact": "ContactCta-module-scss-module__ThFnHW__contact",
  "contact-card": "ContactCta-module-scss-module__ThFnHW__contact-card",
  "content": "ContactCta-module-scss-module__ThFnHW__content",
  "image": "ContactCta-module-scss-module__ThFnHW__image",
  "image-background": "ContactCta-module-scss-module__ThFnHW__image-background",
  "image-container": "ContactCta-module-scss-module__ThFnHW__image-container",
  "posttext": "ContactCta-module-scss-module__ThFnHW__posttext",
  "with-links": "ContactCta-module-scss-module__ThFnHW__with-links",
});
